<template>
    <div class="w-100">
        <div v-if="view.layout && view.layout.rows && document" class="w-100">
            <row-renderer v-for="(row, index) in view.layout.rows" :layout="view.layout" :key="index + view.id + 'FormRow'"
                          :row="row" :index="index" :table="table" :document="document"
                          :view="view"></row-renderer>
        </div>

        <div v-else>
            Layout not complete.
        </div>
    </div>
</template>

<script>
    import TableUtil from "../../utils/TableUtil";

    export default {
        name: 'FormRenderer',
        props: ['view', 'table'],
        data () {
            return {
                document: null,
                model: this.$root.model
            }
        },
        mounted () {
            let tableUtil = new TableUtil()
            this.document = tableUtil.createRecord(this.table)

            if(this.$route && this.$route.query.p) {
                let parentId = this.$route.query.p
                this.document['parent_id'] = parentId
            }
        }
    }
</script>

<style>

</style>
